import React from 'react';

const Footer = () => {
    return (
        <footer className="mcd-footer">
            <div className="mcd-footer-container">
                <div className="mcd-footer-section">
                    <h3 className="mcd-footer-title">About Us</h3>
                    <p className="mcd-footer-text">
We specialize in delivering safe, compliant, cost-effective and performance-oriented management services, aligned with international regulations and the highest standards of maritime operations.                    </p>
                </div>
                <div className="mcd-footer-section">
                    <h3 className="mcd-footer-title">Quick Links</h3>
                    <ul className="mcd-footer-links">
                        <li><a href="/about" className="mcd-footer-link">About</a></li>
                        <li><a href="/services" className="mcd-footer-link">Services</a></li>
                        <li><a href="/contact" className="mcd-footer-link">Contact</a></li>
                        <li><a href="/files/Company Profile.pdf" download className='mcd-footer-link'>Company Profile</a></li>
                        <li><a href="/privacy-policy" className="mcd-footer-link">Privacy Policy</a></li>
                        <li><a href="/terms-and-conditions" className="mcd-footer-link">Terms & Conditions</a></li>
                    </ul>
                </div>
                <div className="mcd-footer-section">
                    <h3 className="mcd-footer-title">Contact & Location</h3>
                    <p className="mcd-footer-text">📍 Colombo & Pannipitiya, Western Province, Sri Lanka</p>
                    <p className="mcd-footer-text">⚓ Operating Ports: Colombo (LKCMB) • Galle • Hambantota</p>
                    <p className="mcd-footer-text"><a href="mailto:info@bluewavesshipmanagement.com">Email: info@bluewavesshipmanagement.com</a></p>
                    <p className="mcd-footer-text"><a href="tel:+94719745745">Phone: +94 719 745 745 (24/7 Support)</a></p>
                    <div className="mcd-footer-social">
                        <a href="https://facebook.com/share/18ojPfJ7D1" target="_blank" rel="noopener noreferrer">f</a>
                        <a href="https://linkedin.com/in/blue-waves-38898536b" target="_blank" rel="noopener noreferrer">in</a>
                        <a href="https://tiktok.com/@blue.waves.ship.m?is_from_webapp-1&sender_device=pc" target="_blank" rel="noopener noreferrer">▶</a>
                    </div>
                </div>
            </div>
            <div className="mcd-footer-bottom">
                <p className="mcd-footer-copyright">
                    &copy; {new Date().getFullYear()} Bluewave Co. All rights reserved. 
                </p>
                 <p className="mcd-footer-copyright">
                        Powered by <a style={{ color: "green", textDecoration: "none" }} href="https://invictustechno.com" target="_blank" rel="noopener noreferrer"> INVICTUS TECHNOLOGY</a>
                    </p>
            </div>
        </footer>
    );
};

export default Footer;